<template>
    <h1 class="mt-2 text-2xl font-bold leading-7 text-gray-900 sm:text-3xl sm:truncate">
        Dashboard
    </h1>
</template>

<script>
import Authenticated from "@/Layouts/Authenticated";
export default {
    layout: Authenticated
}
</script>
